
import { Strategy } from "@/types/strategy-types";

interface TransformedStrategy {
  id: string;
  name: string;
  performance: string;
  riskLevel: string;
  minInvestment: string;
  since: string;
  exchange: string;
  description: string;
  strategy_id: string;
}

export const useStrategyTransform = () => {
  const transformStrategy = (strat?: Strategy): TransformedStrategy | undefined => {
    if (!strat) return undefined;
    
    return {
      id: strat.id,
      name: strat.name,
      performance: strat.expected_monthly_profit?.toString() || "0",
      riskLevel: strat.risk_level?.toString() || "0",
      minInvestment: strat.min_investment?.toString() || "0",
      since: strat.verified_since || new Date().toISOString().split('T')[0],
      exchange: strat.exchange || "",
      description: strat.description || "",
      strategy_id: strat.id
    };
  };

  return { transformStrategy };
};
